var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import { styled } from '../stitches.config';
import { useSpring, animated } from '@react-spring/web';
import { DoubleArrowLeftIcon, DoubleArrowRightIcon, Cross1Icon, } from '@modulz/radix-icons';
export var PanelSurface = styled('div', {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    pointerEvents: 'none',
    overflow: 'hidden',
});
var PanelRoot = styled(animated.div, {
    minWidth: 200,
    backgroundColor: '$glass',
    border: "1px solid $black",
    boxShadow: "inset 0 0 0 1px $white",
    position: 'absolute',
    top: 0,
    bottom: 0,
    overflow: 'visible',
    pointerEvents: 'all',
    display: 'flex',
    flexDirection: 'column',
    padding: '$1',
});
var panelContext = React.createContext(null);
export function Panel(_a) {
    var anchor = _a.anchor, controlledOpen = _a.open, onClose = _a.onClose, rest = __rest(_a, ["anchor", "open", "onClose"]);
    var _b = __read(React.useState(!!controlledOpen), 2), open = _b[0], setOpen = _b[1];
    React.useEffect(function () {
        if (controlledOpen === undefined)
            return;
        setOpen(!!controlledOpen);
    }, [controlledOpen]);
    var toggle = React.useCallback(function () {
        setOpen(function (cur) {
            if (cur)
                onClose === null || onClose === void 0 ? void 0 : onClose();
            return !cur;
        });
    }, [onClose]);
    var value = React.useMemo(function () { return ({
        toggle: toggle,
        open: open,
        anchor: anchor,
    }); }, [toggle, open, anchor]);
    var style = useSpring({
        x: anchor === 'left' ? (open ? '0%' : '-100%') : open ? '0%' : '100%',
        left: anchor === 'left' ? 0 : 'auto',
        right: anchor === 'left' ? 'auto' : 0,
    });
    return (React.createElement(panelContext.Provider, { value: value },
        React.createElement(PanelRoot, __assign({ style: style }, rest))));
}
export var PanelContent = styled('div', {
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
});
var PanelToggleButton = styled('button', {
    border: 'none',
    borderRadius: '100%',
    padding: '$1',
    position: 'absolute',
    lineHeight: 0,
    variants: {
        anchor: {
            left: {
                left: 'calc(100% + 8px)',
            },
            right: {
                right: 'calc(100% + 8px)',
            },
        },
    },
});
export function PanelToggle(_a) {
    var children = _a.children;
    var ctx = React.useContext(panelContext);
    if (!ctx)
        throw new Error('Must be used inside Panel');
    var toggle = ctx.toggle, anchor = ctx.anchor, open = ctx.open;
    return (React.createElement(PanelToggleButton, { onClick: toggle, anchor: anchor }, children !== null && children !== void 0 ? children : React.createElement(PanelToggleIcon, { anchor: anchor, open: open })));
}
function PanelToggleIcon(_a) {
    var anchor = _a.anchor, open = _a.open;
    if (anchor === 'left') {
        if (open) {
            return React.createElement(Cross1Icon, null);
        }
        return React.createElement(DoubleArrowRightIcon, null);
    }
    else {
        if (open) {
            return React.createElement(Cross1Icon, null);
        }
        return React.createElement(DoubleArrowLeftIcon, null);
    }
}
export var PanelHeader = styled('div', {
    paddingLeft: '$1',
    paddingRight: '$1',
    paddingTop: '$2',
    paddingBottom: '$2',
    width: '100%',
});
//# sourceMappingURL=Panel.js.map